import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class AppConfig {

  SERVER_URL: string = window.origin;

  // This is to unit test in development environment
  // SERVER_URL = 'https://wttsrhel8test1.plumchoice.com:1443/smbportal';

  constructor() { }
}
